import { useRef, useEffect } from 'react';

export default function useTimeout(callback, timeout) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (timeout !== null) {
      const id = setTimeout(tick, timeout);

      return () => clearTimeout(id);
    }
  }, [timeout]);
}
